﻿export class NotificationHelper {

    private static _instance: NotificationHelper;

    public static get Instance(): NotificationHelper {
        if (this._instance == null)
            this._instance = new NotificationHelper();

        return this._instance;
    }

    private jqElement: JQuery;
    private kNotification: kendo.ui.Notification;

    constructor() {
        this.jqElement = $("[circ-id='notification']");

        this.kNotification = this.jqElement.kendoNotification({
            position: {
                right: 30,
                bottom: 30
            },
            stacking: "up"
        }).data("kendoNotification");

        this.kNotification.hide();
    }

    show = async (data: Object | String | Function, type: string) => this.kNotification.show(data, type);
    showText = async (data: Object | String | Function, type: string) => this.kNotification.showText(data, type);
    error = async (data: Object | String | Function) => this.kNotification.show(data, "error");
    info = async (data: Object | String | Function) => this.kNotification.show(data, "info");
    success = async (data: Object | String | Function) => this.kNotification.show(data, "success");
    warning = async (data: Object | String | Function) => this.kNotification.show(data, "warning");
    getNotifications = async () => this.kNotification.getNotifications();
    hide = async () => this.kNotification.hide();
}

export class NotificationToolbar {

    private jqElement: JQuery;
    private kToolbar: kendo.ui.ToolBar;
    private jqFetchZone: JQuery;
    private jqVersionBoZone: JQuery;

    private static _instance: NotificationToolbar;

    public static get Instance(): NotificationToolbar {
        if (this._instance == null)
            this._instance = new NotificationToolbar();

        return this._instance;
    }

    constructor() {
        const div = $("<div></div>");
        div.css({width: "100%", height: "100%"});
        $("#panel-bottom").append(div);

        this.jqElement = div;

        this.kToolbar = this.jqElement.kendoToolBar({
            size: "small",
            items: [
                {
                    type: "separator"
                },
                {template: "<span circ-id='fetchzone'></span>"},
                {
                    type: "separator"
                },
                {type: "spacer"},
                {template: "<a href='#' circ-id='skill_link' title='Télécharger le skill easymail-templates pour votre agent IA'>Skill IA</a>"},
                {
                    type: "separator"
                },
                {template: "<span circ-id='version_bo_zone'></span>"},

            ]
        }).data("kendoToolBar");

        this.jqFetchZone = this.jqElement.find("[circ-id='fetchzone']");
        this.jqVersionBoZone = this.jqElement.find("[circ-id='version_bo_zone']");

        // Import différé : SkillDialog dépend de ce module (notifications).
        this.jqElement.find("[circ-id='skill_link']").on("click", (e) => {
            e.preventDefault();
            import("../Component/Skill/SkillDialog.js").then(m => m.SkillDialog.Open());
        });

    }

    public FetchMessage = async (message: string) => {
        this.jqFetchZone.text(message);
    }

    public BoVersionMessage = async (message: string) => {
        this.jqVersionBoZone.text("BO-EasyMail : " + message);
    }

}